import { Resource } from 'i18next';

import { createI18nInstance } from '@digital-services/ui';

import navMenuEN from "./src/locales/en/navMenu.json";

import translationEN from './src/locales/en/translation.json';

const resources: Resource = {
  en: { 
    translation: translationEN,
    navMenu: navMenuEN
  }
};

const instance = createI18nInstance(resources);

export default instance;
